import { CommentableType } from 'components/ActivityEvent/Types'
import { useAuth } from 'hooks/UseAuth'
import { Comment, CommentStatus } from 'types'

export const useCommentPermissions = (comment: Comment, inCleanupMode: boolean = false) => {
  const auth = useAuth()
  const isAuthor = auth?.id === comment.user.id
  const isReply = comment.commentable_type !== CommentableType.ARTICLE
  const isResolved = comment.status === CommentStatus.Resolved

  const cleanupPermissions = {
    canReact: true,
    canTogglePin: false,
    canToggleResolved: !isReply,
    canEdit: false,
    canRename: false,
    canDelete: false,
  }

  if (inCleanupMode) return cleanupPermissions

  return {
    canReact: true,
    canTogglePin: !isResolved && !isReply,
    canToggleResolved: !isReply,
    canEdit: isAuthor,
    canRename: !isReply && isAuthor,
    canDelete: isAuthor,
  }
}
